import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/distinte-riba/_layout/'
)({
  component: () => null,
});
